import React, {PureComponent} from 'react';
import ArtifactImage from './artifact_image';
import InventoryItemInterface from 'app/interfaces/InventoryItemInterface';

interface ArtifactImagesProps {
    recipes: InventoryItemInterface[]
}

export default class ArtifactImages extends PureComponent<ArtifactImagesProps> {
    render(): JSX.Element[] {
        const {recipes} = this.props;
        return recipes.map(recipe => <ArtifactImage
            key={recipe.id}
            recipe={recipe}
        />);
    }
}
